import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import { SAT_BASIC_05_Schema } from './SAT_BASIC_05_Schema';

export const useSearchCode = (options = {}) => {
  const { onSuccess } = options;

  const query = useQuery({
    queryKey: ['Utility', 'getCodeInfo'],
    queryFn: () => apiRequest('post', Global.urls.Utility.getCodeInfo),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SAT_BASIC_05_Schema.mapper.search1);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const query = useQuery({
    queryKey: ['SafetyHealthTraining', 'getSatBasic05R1', params],
    queryFn: () =>
      apiRequest(
        'post',
        Global.urls.SafetyHealthTraining.getSatBasic05R1,
        params
      ),
    enabled: !!searchInfo?.custCd,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SAT_BASIC_05_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SafetyHealthTraining.getSatBasic05R2,
      params
    );
  }, successOptions);
};
export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SAT_BASIC_05_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.Member.getMemBasicR1, params);
  }, successOptions);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAT_BASIC_05_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.SafetyHealthTraining.saveSatBasic05U1,
      payload
    );
  }, options);
};
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAT_BASIC_05_Schema.mapper.save2);
    return apiRequest(
      'post1',
      Global.urls.SafetyHealthTraining.saveSatBasic05U2,
      payload
    );
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAT_BASIC_05_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.SafetyHealthTraining.deleteSatBasic05D1,
      payload
    );
  }, options);
};

export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAT_BASIC_05_Schema.mapper.delete2);
    return apiRequest(
      'post1',
      Global.urls.SafetyHealthTraining.deleteSatBasic05D2,
      payload
    );
  }, options);
};
